<template>
    <div>
        <notifications position="top center" group="info" />

        <h1>Messages</h1>

        <b-tabs>
            <b-tab title="Messages reçus">
                <br />
                <listmessages :mode="'to'" :messages="messages_to" @seen="seen" @delete="deleteMessage"></listmessages>
            </b-tab>
            <b-tab title="Messages envoyés">
                 <br />
                <listmessages :mode="'from'" :messages="messages_from" @delete="deleteMessage"></listmessages>
            </b-tab>
            <b-tab title="Nouveau message">
                <newmessage></newmessage>
            </b-tab>
        </b-tabs>
    </div>

</template>

<script>
	import store from "../store.js";
    import messages_services from "../services/messages.js";
    import newmessage from "./MessageSend.vue";
    import viewmessage from "./Message.vue";
    import listmessages from "./MessagesList.vue";

	export default {
        name: "messages",
        components: {
            newmessage,
            viewmessage,
            listmessages
        },
		data: function () {
			return {
                messages_from: [],
                messages_to: []
			};
		},
        computed: {
			message() {
				return this.$store.getters.getMessage
            },
            isAdmin: function() {
                return store.getters.isUserAdmin;
            }
        },
		watch: {
			message: async function () {
                if (!this.message)
                    return;

                //console.log(this.message)
                var message = await messages_services.get(this.message);
                //console.log(message)

                var user_uid = store.state.user.uid;
                if (this.isAdmin)
                    user_uid = null;

                
                if (!message)
                {
                    message = {
                        uid: this.message,
                        dest: user_uid,
                        sender: user_uid,
                        active_dest: false,
                        active_sender: false
                    }
                }

                if (message.dest == user_uid)
                {
                    let n = true;
                    for (let i = 0; i < this.messages_to.length; i++)
                    {
                        if (this.messages_to[i].uid == message.uid)
                        {
                            if (message.active_dest)
                            {
                                this.$set(this.messages_to, i, message);
                            }
                            else
                            {
                                this.messages_to.splice(i, 1);
                                i--;
                            }
                            n = false;
                        }
                    }
                    if (n && message.active_dest)
                        this.messages_to.unshift(message);
                }
                if (message.sender == user_uid)
                {
                    let n = true;
                    for (let i = 0; i < this.messages_from.length; i++)
                    {
                        if (this.messages_from[i].uid == message.uid)
                        {
                            if (message.active_sender)
                            {
                                this.$set(this.messages_from, i, message);
                            }
                            else
                            {
                                this.messages_from.splice(i, 1);
                                i--;
                            }
                            n = false;
                        }
                    }
                    if (n && message.active_sender)
                        this.messages_from.unshift(message);
                }
                this.$store.commit("setMessage", null);
            },
        },
		methods: {
            async seen(uid)
            {
                for (var i = 0; i < this.messages_to.length; i++)
                {
                    if (this.messages_to[i].uid == uid)
                    {
                        this.messages_to[i].seen = true;
                        this.$set(this.messages_to, i, this.messages_to[i]);
                        await messages_services.seen(this.messages_to[i].uid);
                        
                        // Mettre à jour le compteur
                        var unseen_messages = await messages_services.getUnseenNb();
                        this.$store.commit("setUnseenMessages", unseen_messages);
                    }
                }
            },
            async deleteMessage(uid, mode)
            {
                var messages = (mode == "to" ? this.messages_to : this.messages_from)

                for (var i = 0; i < messages.length; i++)
                {
                    if (messages[i].uid == uid)
                    {
                        await messages_services.delete(messages[i].uid)
                        messages.splice(i, 1);
                        i--;
                    }
                }

                // Mettre à jour le compteur
                var unseen_messages = await messages_services.getUnseenNb();
                this.$store.commit("setUnseenMessages", unseen_messages);

                //console.log(messages)
            }
		},
		mounted: async function () {
            
            if (store.state.user.rules && !store.state.user.rules.messages) {
                this.$router.push({ name: "profile" });
            }

            var messages = await messages_services.list();

            this.messages_from = messages.messages_from;
            this.messages_to = messages.messages_to;
		},
	};
</script>
